import React, { Component } from "react"

export default class Footer extends Component {
  render() {
    return (
      <footer
        style={{
          padding: 0
        }}
      >
        <div
          className="card content"
          style={{
            marginBottom: 2,
            marginLeft: 10,
            marginRight: 10,
            width: "98%"
          }}
        >
          <div className="row" style={{ display: "inline" }}>
            <div className="col-md-6 col-md-offset-4">
              <span style={{ marginLeft: 0 }}>
                <strong>2017 © </strong>Véritas Assessoria, Consultoria e
                Auditoria Eireli
              </span>
            </div>
            <div className="col-md-6 col-md-offset-4">
              <span style={{ marginLeft: 40 }}>
                <strong>Prefeitura Municipal de Juazeiro do Norte</strong>
              </span>
            </div>
            <div className="col-md-6 col-md-offset-4">
              <span style={{ marginLeft: 50 }}>
                Palácio Municipal José Geraldo da Cruz
              </span>
            </div>
            <div className="col-md-6 col-md-offset-4">
              <span style={{ marginLeft: 10 }}>
                Praça Dirceu Figueiredo S/N Centro CEP: 63.010-010
              </span>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js